import {
  BagIcon,
  DollarCircleIcon,
  NoteIcon,
  ShopIcon,
  SMSIcon,
  TaskIcon,
} from '@c/icons';
import { useNotifications } from './useNotifcations';
import { useMemo } from 'react';
import { UserDocument } from 'models/user';

interface MenuItemType {
  label: string;
  icon?: React.ReactNode;
  badgeCount?: number;
}
export interface DropdownMenuItemType extends MenuItemType {
  onClick: () => void;
  href?: string;
}

export interface NavMenuItemType extends MenuItemType {
  href: string;
  onClick?: () => void;
}

const useMenuItems = (userDoc: UserDocument | null | undefined) => {
  const menuItems: NavMenuItemType[] = [
    {
      label: 'Sell your gear',
      href: '/how-it-works',
    },
    {
      label: 'Seller fees',
      href: '/about',
    },
    {
      label: 'Why MX Locker?',
      href: '/about',
    },
    {
      label: 'MX Locker protection',
      href: '/about',
    },
    {
      label: 'Seller center',
      href: '/about',
    },
  ];

  const helpItems = [
    {
      label: 'About us',
      href: '/about',
    },
    // {
    //   label: 'Contact',
    //   href: '/contact',
    // },
    {
      label: 'FAQ',
      href: '/faq',
    },
    {
      label: 'Terms & Conditions',
      href: '/terms-and-conditions',
    },
  ];

  const { unreadCount, pendingOrdersCount } = useNotifications();

  const accountItems: NavMenuItemType[] = [
    {
      label: 'Messages',
      href: '/dashboard/messages',
      icon: <SMSIcon />,
      badgeCount: unreadCount,
    },
    {
      label: 'Purchases',
      href: '/dashboard/purchases',
      icon: <BagIcon />,
    },
  ];

  const sellerAccountItems = [
    {
      label: 'Seller Dashboard',
      href: '/dashboard/shop-overview',
      icon: <ShopIcon />,
    },
    {
      label: 'Listings',
      href: '/dashboard/listings',
      icon: <NoteIcon />,
    },
    {
      label: 'Orders',
      href: '/dashboard/orders',
      icon: <TaskIcon />,
      badgeCount: pendingOrdersCount,
    },
  ];

  const filteredSellerAccountItems = useMemo(() => {
    return sellerAccountItems;
  }, [userDoc]);

  return {
    menuItems,
    helpItems,
    accountItems,
    sellerAccountItems: filteredSellerAccountItems,
  };
};

export default useMenuItems;
